import React from 'react';
import { Navbar, Container, Button } from 'react-bootstrap';
import { Bell } from 'lucide-react';
import UserDropdown from '../UserDropdown/UserDropdown'

const TopNav = () => {
  return (
    <Navbar 
      fixed="top" 
      style={{ 
        backgroundColor: '#28a745',
        zIndex: 1030 // Ensure it's above the left nav
      }} 
      className="shadow-sm"
    >
      <Container fluid className="px-4">
        <div className="d-flex align-items-center">
          {/* Space for logo */}
          <div className="me-2" style={{ width: '30px', height: '30px' }}></div>
          {/* App name */}
          <span className="text-white fs-6 fw-semibold text-nowrap">Neoantigen Prediction Service</span>
        </div>

        <div className="ms-auto d-flex align-items-center gap-2">
          <Button variant="link" className="text-white p-1">
            <Bell size={20} />
          </Button>
          <UserDropdown />
        </div>
      </Container>
    </Navbar>
  );
};

export default TopNav;